import script from "./MailExternal.vue?vue&type=script&setup=true&lang=js"
export * from "./MailExternal.vue?vue&type=script&setup=true&lang=js"

import "./MailExternal.vue?vue&type=style&index=0&id=3de6d697&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3de6d697"]])

export default __exports__